import { ResourceType } from '@dbt-labs/dbt-dag';
import { Heading, Tooltip } from '@dbt-labs/sourdough';

import { ResourceTypeCard } from '@/components/ResourceTypeCard';
import { useDbtCloudAccount } from '@/context/DbtCloudProvider';
import { RecentlyViewedRecord, useRecentlyViewed } from '@/hooks/admin/recentlyViewed';

export const RecentlyViewed = () => {
  const { accountId } = useDbtCloudAccount();
  const recentlyViewedQuery = useRecentlyViewed(accountId ?? 0);

  if (!recentlyViewedQuery?.data || recentlyViewedQuery.data.length === 0) {
    return null;
  }

  return (
    <div className="mb-12">
      <div className="my-4">
        <Heading size="4">Recently viewed</Heading>
      </div>
      <div className="grid gap-4 sm:grid-cols-2 md:grid-cols-3 ml:grid-cols-5">
        {recentlyViewedQuery.data.map((record, _) => (
          <div key={`recently-viewed-${record.url}`} className="w-full">
            <RecentlyViewedCard {...record} />
          </div>
        ))}
      </div>
    </div>
  );
};

const RecentlyViewedCard = ({
  name,
  url,
  resourceType,
  description,
}: RecentlyViewedRecord) => {
  return (
    <ResourceTypeCard
      resourceType={resourceType as ResourceType}
      href={url}
      className="h-full"
    >
      <Tooltip content={name} displayOnlyWhenTruncated>
        {(ref) => (
          <span ref={ref} className="font-label-lg block truncate pt-4">
            {name}
          </span>
        )}
      </Tooltip>
      <span className="block">
        {description ? (
          <p className="font-caption line-clamp-6 overflow-hidden">{description}</p>
        ) : (
          <p className="font-caption overflow-hidden text-fgDecorative">
            This resource does not have a description.
          </p>
        )}
      </span>
    </ResourceTypeCard>
  );
};
